import { gql } from "@apollo/client";
const ADDRESSES = gql`
  query addresses {
    addresses {
      __typename
      ... on Address {
        id
        location_id
        street_name
        street_number
        floor
        department
        location {
          postal_code
          name
        }
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { ADDRESSES };
